import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';

@Component({
    selector: 'app-release-notes',
    //standalone: true,
    //imports: [],
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.css'],
    standalone: false
})
export class ReleaseNotesComponent {
  links: any[] = [];

  //constructor(private http: HttpClient) { }
}
